import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { showToast } from "../../utils/utils";
import { platformPartner, buttonName, alertActions } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { getloadPlatformPartnersURL } from "../../utils/constants/apiEndPoints";
import privateAxios from "../../utils/axiosPrivate";
import { PLATFORM_PARTNER_APIS } from "../../route/paths";

const CreatePlatformPartnerApi = () => {
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const initialPlatformPartner = {
    clientName: "",
    allowedIp: "",
    accessToken: "",
    webhookEndpointUrl: "",
    webhookCustomHeaders: "",
    webhookSecretToken: ""
  };
  const [platformpartner, setPlatformpartner] = useState(
    initialPlatformPartner
  );

  const handleinputChange = (event) => {
    const { name, value } = event.target;

    setPlatformpartner((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const validate = () => {
    const tempErrors = {};

    if (!platformpartner.clientName)
      tempErrors.clientName = platformPartner?.create.errMsg.nameErr;
    if (!platformpartner.allowedIp)
      tempErrors.allowedIp = platformPartner?.create.errMsg.ipErr;
    if (!platformpartner.webhookEndpointUrl)
      tempErrors.webhookEndpointUrl = platformPartner?.create.errMsg.webhookErr;

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const dataTosend = {
        ...platformpartner
      };

      const response = await privateAxios.post(
        getloadPlatformPartnersURL,
        dataTosend
      );

      if (response.status === 201) {
        showToast(response.data.message, showToastType?.success);
        navigate(PLATFORM_PARTNER_APIS);
      }
    } catch (error) {
      showToast(error.response.data.errors, showToastType?.error);
    }
  };

  const handleCancel = () => {
    setPlatformpartner({});
    navigate(PLATFORM_PARTNER_APIS);
  };

  return (
    <>
      <TablePagesTitle mainTitle={platformPartner?.mainTitle} />
      <AccessPageAction subheading={platformPartner?.create.title} />
      <div className="row mb-3 mx-0">
        <div className="col-md-12 sale-leade-form mt-3">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="name">{platformPartner?.create.name}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder={platformPartner?.create.name}
                    name="clientName"
                    onChange={handleinputChange}
                    value={platformpartner.clientName}
                  />
                  {errors.clientName && (
                    <div className="text-danger small">{errors.clientName}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="address">{platformPartner?.create.ip}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder={platformPartner?.create.ip}
                    name="allowedIp"
                    onChange={handleinputChange}
                    value={platformpartner.allowedIp}
                  />
                  {errors.allowedIp && (
                    <div className="text-danger small">{errors.allowedIp}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="Webhook">
                    {platformPartner?.create.webhookURL}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder={platformPartner?.create.webhookURL}
                    name="webhookEndpointUrl"
                    onChange={handleinputChange}
                    value={platformpartner.webhookEndpointUrl}
                  />
                  {errors.webhookEndpointUrl && (
                    <div className="text-danger small">
                      {errors.webhookEndpointUrl}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="additional">
                    {platformPartner?.create.webhookHeaders}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder={platformPartner?.create.webhookHeaders}
                    name="webhookCustomHeaders"
                    onChange={handleinputChange}
                    value={platformpartner.webhookCustomHeaders}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-5 d-flex d-sm-block justify-content-center justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions?.Cancel}
                </button>
                <button type="submit" className="btn btn-primary">
                  {buttonName?.create}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreatePlatformPartnerApi;
